@if (group$ | async; as groups) {
<div class="container">
  <app-title-header></app-title-header>
  <section id="host-header" class="card">
    <ng-container>
      <div class="inline-content">
        <span data-testid="host-display-name">{{ groups.name }}</span>
        <span class="title" i18n="@@GROUP_TYPE_SELECTION.TITLE">
          Select event types from the options below
        </span>
      </div>
    </ng-container>
  </section>
  <div id="meeting-type-container" class="row row-gutters">
    @for (meetingType of groups.associations; track meetingType) {
    <div class="col col-xs-12 col-sm-6">
      <mat-card
        class="meeting-type-card"
        [routerLink]="meetingType.bookingUrl | bookingUrlPipe"
        [queryParamsHandling]="'preserve'"
      >
        <mat-card-header>
          <mat-icon
            mat-card-avatar
            class="meeting-type-icon mat-elevation-z2"
            [style.background-color]="meetingType.hexColor"
          >
            access_time
          </mat-icon>
          <mat-card-title>{{ meetingType.name }}</mat-card-title>
          <mat-card-subtitle
            >{{
              durationMinutes(meetingType.duration)
            }}
            minutes</mat-card-subtitle
          >
        </mat-card-header>
        <mat-card-content>
          <div
            class="meeting-type-description"
            matTooltip="{{ meetingType.description }}"
            matTooltipPosition="below"
          >
            <span>{{ meetingType.description }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    }
  </div>
  @if (navigationService.canGoBack()) {
  <button
    class="back-button"
    mat-stroked-button
    (click)="navigationService.goBack()"
  >
    Back
  </button>
  }
</div>
} @else { @if (loadingForEnoughTime$ | async) {
<div class="row row-gutters">
  @for (i of [].constructor(6); track i) {
  <div class="col col-xs-12 col-sm-6">
    <div class="stencil-shimmer meeting-type-card">
      <div
        class="meeting-type-icon mat-elevation-z2 stencil-shimmer disappear-on-mobile"
      ></div>
    </div>
  </div>
  }
</div>
} }
